export default class ExternalDatabaseService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  /** Status der Anbindung an die externe Sagasser-Datenbank: { enabled, description, message }. */
  async getStatus(options) {
    const response = await fetch(`${this.baseUrl}/externalDatabase/status`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`)
    }

    return await response.json()
  }
}
